import { CreditcardParticipantsShow } from './CreditcardParticipantsShow'
import { CreditcardParticipantsCreate } from './CreditcardParticipantsCreate'

export const creditcard_participants = {
  show: CreditcardParticipantsShow,
  create: CreditcardParticipantsCreate,
}
